import vClickOutside from "click-outside-vue3";
import type { App } from "vue";
import VueCookies from "vue3-cookies";

import setSessionId from "@/env/setSessionId";
import { Statsig } from "@/env/statsig/client";
import router from "@/router";
import store from "@/store/index";
import { headInstance } from "@/utils/headInstance";
import isUnauth from "@/utils/isUnauth";

await setSessionId();

// app is the Vue app instance
export default function populateApp(app: App) {
  //get existing basketId from local storage
  const basketId = localStorage.getItem("BASKET_ID");

  // initialize Statsig for unauth users
  if (Statsig.isEnabled() && isUnauth()) {
    Statsig.init();
  }

  if (import.meta.env.PROD) {
    globalThis?.gtagInit(
      globalThis,
      document,
      "script",
      "dataLayer",
      globalThis.env.GTM_ID
    );
  }

  // Clear local storage
  localStorage.clear();

  // Set the basketId in local storage
  localStorage.setItem("BASKET_ID", basketId ?? "NA");

  app
    .use(router)
    .use(VueCookies)
    .use(store)
    .use(vClickOutside)
    .use(headInstance);

  // if route is ready, mount the app
  router.isReady().then(() => {
    // Prefetch pricing data BEFORE mounting to avoid delay in subscription days display
    try {
      if (isUnauth()) {
        // Unauthenticated users: fetch subscription pricing
        store.dispatch("pricing/fetchSubscriptions");
      } else {
        // Authenticated users: fetch product pricing
        store.dispatch("pricing/fetchPrices");
      }
    } catch {
      // Silently fail - pricing will be fetched on-demand if needed
    }

    app.mount("#app");
  });
  return app;
}
